import React from 'react';
import { Channel } from '../contexts/WalkieContext';

interface ChannelTabsProps {
  channels: Channel[];
  activeChannelId: string | null;
  onSwitch: (channelId: string) => void;
}

export default function ChannelTabs({ channels, activeChannelId, onSwitch }: ChannelTabsProps) {
  return (
    <div className="flex items-center gap-1 px-4 py-2 bg-gray-800 border-b border-gray-700 overflow-x-auto">
      {channels.map((channel, idx) => {
        const isActive = channel.id === activeChannelId;
        const hasSpeaker = !!channel.activeSpeaker;
        const isEmergency = channel.type === 'emergency';

        return (
          <button
            key={channel.id}
            onClick={() => onSwitch(channel.id)}
            className={`
              flex items-center gap-2 px-4 py-2 rounded-t-lg whitespace-nowrap transition-all
              ${isActive
                ? 'bg-gray-900 border-b-2 border-emerald-500 text-emerald-400'
                : 'bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-gray-200'
              }
              ${isEmergency ? 'border-b-red-500' : ''}
            `}
          >
            {/* Channel number hint */}
            {idx < 9 && (
              <span className="text-xs text-gray-600 font-mono">{idx + 1}</span>
            )}

            {/* Channel name */}
            <span className="text-sm font-semibold">{channel.name}</span>

            {/* Member count */}
            <span className="text-xs text-gray-500">({channel.memberCount})</span>

            {/* Active speaker dot */}
            {hasSpeaker && (
              <span className="flex items-center gap-1">
                <span className="w-2 h-2 rounded-full bg-emerald-500 speaker-dot"></span>
                <span className="text-xs text-emerald-400">{channel.activeSpeaker}</span>
              </span>
            )}

            {/* Emergency indicator */}
            {isEmergency && (
              <span className="text-red-500 text-xs">🆘</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
